let scriptEl = null;
let scriptLoaded = false;

export function loadMailchimpScript(scriptLoaded) {
  if (scriptLoaded) return;

  scriptEl = document.createElement('script');
  scriptEl.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
  scriptEl.async = true;
  scriptEl.onload = () => {
    scriptLoaded = true;
    if (window.mc && window.mc.validate) {
      window.mc.validate(); // Initialize validation
    }
  };
  scriptEl.onerror = () => {
    console.error('Failed to load Mailchimp script');
  };
  document.body.appendChild(scriptEl);
}

export function removeMailchimpScript(scriptLoaded) {
  if (scriptEl) {
    document.body.removeChild(scriptEl);
    scriptLoaded = false;
    scriptEl = null;
  }
}